import { render } from "./WordcloudOverview.vue?vue&type=template&id=48d52ca4&scoped=true"
import script from "./WordcloudOverview.vue?vue&type=script&lang=js"
export * from "./WordcloudOverview.vue?vue&type=script&lang=js"

import "./WordcloudOverview.vue?vue&type=style&index=0&id=48d52ca4&lang=scss&scoped=true"
import "./WordcloudOverview.vue?vue&type=style&index=1&id=48d52ca4&lang=scss"
import "./WordcloudOverview.vue?vue&type=style&index=2&id=48d52ca4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d52ca4"]])

export default __exports__